import { API_PREFIX } from "./api.constants";

export const PERMISSION_ENDPOINTS = {
  PERMISSIONS: `${API_PREFIX}/permissions`,
  PERMISSION_DETAIL: (permId: number | string) => `${API_PREFIX}/permissions/${permId}`,
  PERMISSIONS_EXPORT: `${API_PREFIX}/permissions/export`,
};